<template>
  <div>
    <div class="bg-section-projects">
      <v-col
        lg="5"
        md="10"
      >
        <div class="pl-10 pt-10 pb-10 pr-10">
          <v-stepper
            v-model="workerCheckIn"
            light
            class="my-stepper-style"
            elevation="0"
          >
            <v-stepper-header>
              <v-stepper-step
                :complete="workerCheckIn > 1"
                step="1"
                color="#37474F"
              />

              <v-divider />

              <v-stepper-step
                :complete="workerCheckIn > 2"
                step="2"
                color="#37474F"
              />

              <v-divider />

              <v-stepper-step
                :complete="workerCheckIn > 3"
                color="#37474F"
                step="3"
              />
            </v-stepper-header>
          </v-stepper>
          <select-project
            v-if="showSelectProject"
            @selected-project="toSecondStep"
          />
          <select-work-types
            v-if="showSelectWorkTypes"
            :project-id="projectId"
            @selected-work-type="toThirdStep"
            @cancel="toFirstStep"
          />
          <review-details
            v-if="showReviewDetails"
            :button-text="'Next'"
            @reviewed-details="toCheckInSuccess"
            @cancel="toSecondStep"
          />
          <continue-same-check-in
            v-if="continueSameCheckIn"
            @closed="continueSameCheckIn = false"
          />
        </div>
      </v-col>
    </div>
    <centre-spinner :loading="loading" />
  </div>
</template>

  <script>
  import spinner from '../../../components/SpinnerCentre.vue';
  import SelectProject from './SelectProject.vue';
  import SelectWorkTypes from './SelectWorkTypes.vue';
  import ReviewDetails from './ReviewDetails.vue';
  import ContinueSameCheckIn from '../dialogs/ContinueSameCheckIn.vue';
  export default {
    name: 'HomePage',
    components: {
      'centre-spinner': spinner,
      'select-project': SelectProject,
      'select-work-types': SelectWorkTypes,
      'review-details': ReviewDetails,
      'continue-same-check-in': ContinueSameCheckIn,
    },
    data () {
      return {
        loading: false,
        showSelectProject: true,
        step1SuccessColor: '',
        showSelectWorkTypes: false,
        step2SuccessColor: '',
        showReviewDetails: false,
        workerCheckIn: 1,
        projectId: null,
        continueSameCheckIn: false,
        ispreviousCheckIn: false,
      };
    },
    computed: {
      step1Success () {
        return `color:${this.step1SuccessColor}`;
      },
      step2Success () {
        return `color:${this.step2SuccessColor}`;
      },
      getWorker () {
       return this.$store.getters.getWorker;
      },
      appUserCheckInRecord () {
      return this.$store.getters['devices/getActiveCheckInDetails'];
      },
      previousCheckInDetails () {
        return this.$store.getters['devices/getPreviousCheckInDetails'];
      },
      ispreviousCheckInDetails () {
      if (Object.keys(this.previousCheckInDetails.length === 0)) {
       return false;
      }
      return true;
      },
      checkType () {
       return this.previousCheckInDetails.work_details.type;
      },
      selectedOrganization () {
        return this.$store.getters.getSelectedOrganization;
      },
    },
    mounted () {
      this.checkUserExist();
      this.getCheckInRecords();
    },
    methods: {
      toFirstStep () {
        this.showSelectProject = true;
        this.showSelectWorkTypes = false;
        this.showReviewDetails = false;
        this.step1SuccessColor = '#00796B';
        this.workerCheckIn = 1;
      },
      toSecondStep (id) {
        this.showSelectProject = false;
        this.showSelectWorkTypes = true;
        this.showReviewDetails = false;
        this.step1SuccessColor = '#00796B';
        this.workerCheckIn = 2;
        this.projectId = id;
      },
      toThirdStep () {
        this.showSelectProject = false;
        this.showSelectWorkTypes = false;
        this.showReviewDetails = true;
        this.step1SuccessColor = '#00796B';
        this.workerCheckIn = 3;
      },
      async toCheckInSuccess () {
        await this.$store.dispatch('devices/workerLogout');
        await this.$store.dispatch('kioskUserLogout');
        setTimeout(() => {
          this.$router.push({ name: 'DeviceCheckInCheckOut' });
        }, 1000);
      },
      checkUserExist () {
if (Object.keys(this.getWorker).length === 0) {
  this.$router.push({ name: 'DeviceCheckInCheckOut' });
}
      },
      async getCheckInRecords () {
       await this.$store.dispatch('devices/fetchUsersCurrentCheckInDetails');
    },
    async getPreviousCheckInDetails () {
        this.loading = true;
        await this.$store.dispatch('devices/fetchPreviousCheckInDetails', {
          orgExtId: this.selectedOrganization.organization.external_id,
        }).then(() => {
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
      async goToSameCheckIn () {
        this.continueSameCheckIn = true;
      },
    },
  };
  </script>

  <style scoped>
  .v-stepper__header {
    background: #F5F5F5;
  }
  .v-stepper__step {
    padding: 10px;
  }
  .v-stepper__header .v-divider {
    margin: 0 3px;
  }
  </style>
